// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"49":"join","443":"about","587":"community","631":"contact","860":"menu"}[chunkId] + "-legacy." + {"49":"b9cffe2d","443":"285050d0","587":"e9dfd9ef","631":"1e8a6529","860":"a263b747"}[chunkId] + ".js";
};